/**
 * Centralized logger utilities for the web client.
 */

const PREFIX = '[VRMeet]';

function buildArgs(message: string, context?: unknown): unknown[] {
  if (context === undefined) {
    return [PREFIX, message];
  }

  return [PREFIX, message, context];
}

/**
 * Logs informational messages for runtime visibility.
 */
export function logInfo(message: string, context?: unknown): void {
  console.info(...buildArgs(message, context));
}

/**
 * Logs warning messages for recoverable issues.
 */
export function logWarning(message: string, context?: unknown): void {
  console.warn(...buildArgs(message, context));
}

/**
 * Logs error messages for failures.
 */
export function logError(message: string, context?: unknown): void {
  console.error(...buildArgs(message, context));
}

/**
 * Logs debug messages for development inspection.
 */
export function logDebug(message: string, context?: unknown): void {
  console.debug(...buildArgs(message, context));
}
